<template>
  <div class="job-offer__pagination">
    <ArrowButton reverse small grey @click="$emit('navigate', currentPage - 1)" :disabled="currentPage === 0"/>
    <button v-for="page in pages" :key="`pagination-${page}`" @click="$emit('navigate', page - 1)"
            :class="['job-offer__pagination-button', {'--active': currentPage === page - 1}]">
      {{ page }}
    </button>
    <ArrowButton small grey  @click="$emit('navigate', currentPage + 1)" :disabled="currentPage === pages - 1"/>
  </div>
</template>

<script>
import {ArrowButton} from '@/components/small'

export default {
  name: 'JobOfferPagination',
  components: {ArrowButton},
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    paginationSize: {
      type: Number,
      required: true
    },
    offersLength: {
      type: Number,
      required: true
    }
  },
  computed: {
    pages() {
      return Math.ceil(this.offersLength / this.paginationSize)
    }
  },
  emits: ['navigate']
}
</script>